<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="系统名称" name="first">
        <el-form class="main-form" ref="form" label-position="left">
          <el-form-item label="系统名称:">
            <el-input class="form-item-length" type="text" v-model="textSystemName" maxlength="20"
                      show-word-limit></el-input>
          </el-form-item>
          <el-button @click="onSaveSystemName" type="primary" :disabled="!hasCommitPermission">保存</el-button>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="公司logo" name="second">
        <el-form class="main-form" ref="form">
          <el-form-item label="logo图:">
            <el-upload
                class="upload-demo"
                ref="upload"
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-remove="handleLogoRemove"
                :on-change="handleLogoChange"
                :multiple="false"
                :file-list="fileLogoList"
                :limit="1"
                :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>

          <el-button @click="onSaveSystemLogo" type="primary" :disabled="!hasCommitPermission">保存</el-button>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="单位欢迎词" name="third">
        <el-form class="main-form" ref="form">
          <el-form-item label="单位欢迎词:">
            <el-input class="form-item-length" type="text" v-model="textWelcomePage" maxlength="20"
                      show-word-limit></el-input>
          </el-form-item>
          <el-button @click="onSaveWelcomePage" type="primary" :disabled="!hasCommitPermission">保存</el-button>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>


<script>

import {getMobileSettingInfo, setSystemSettingInfo} from "@/api/setting-api";
import {getFileUrl, uploadFile} from "@/utils/fileUploadUtils";

export default {
  name: "MobileDeviceSetting",
  data() {
    return {
      activeName: "first",

      textSystemName: "",

      textWelcomePage: "",

      fileLogoList: [],
      logoChanged: false,
    }
  },

  mounted() {
    getMobileSettingInfo().then(({data}) => {
      console.log("getMobileSettingInfo", data)
      if (data.code === 200) {
        this.setupData(data.data)
      } else {
        console.log("getMobileSettingInfo false", data.msg)
        this.showServerErrMsg(data.msg)
      }
    }).catch(err => {
      console.error("getMobileSettingInfo err", err)
      this.showNetErrMsg()
    })

  },
  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("SYSTEM_SETTING_MODIFY")
        default:
          return false
      }
    },
  },

  methods: {

    setupData(data) {
      if (data == null || data.length === 0) {
        return
      }
      data.forEach(item => {
        switch (item.type) {
          case "SYSTEM_NAME":
            this.textSystemName = item.content
            break
          case "COMPANY_LOGO":
            this.setLogoPic(item.content)
            break
          case "HOME_WELCOME":
            this.textWelcomePage = item.content
            break
          default:
            break
        }
      })
    },

    setLogoPic(content) {
      let url = getFileUrl(content)
      this.fileLogoList = [{name: 'logo.png', url: url}]
    },


    doSetSystemSettingInfo(type, content) {
      const postData = {target: "MOBILE", state: "VALID", type: type, content: content}
      console.log("doSetSystemSettingInfo data:", postData)
      setSystemSettingInfo(postData).then(({data}) => {
        console.log("doSetSystemSettingInfo return", data)
        if (data.code === 200) {
          this.$message.success("设置成功")
        } else {
          console.log("setSystemSettingInfo false", data.msg)
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.error("setSystemSettingInfo err", err)
        this.showNetErrMsg()
      })
    },

    onSaveSystemName() {
      this.doSetSystemSettingInfo("SYSTEM_NAME", this.textSystemName)
    },

    onSaveSystemLogo() {
      if (!this.logoChanged) {
        this.$message.warning("logo图未修改")
        return
      }
      if (this.fileLogoList.length === 0) {
        this.doSetSystemSettingInfo("COMPANY_LOGO", "")
        return;
      }

      let companyLogo = `manager/${this.fileLogoList[0].name}`
      uploadFile(this.fileLogoList[0], companyLogo)
      this.doSetSystemSettingInfo("COMPANY_LOGO", companyLogo)
    },

    onSaveWelcomePage() {
      this.doSetSystemSettingInfo("HOME_WELCOME", this.textWelcomePage)
    },

    handleLogoRemove(file, fileList) {
      console.log("handleLogoRemove", file, fileList);
      this.fileLogoList = fileList
      this.logoChanged = true
    },
    handleLogoChange(file, fileList) {
      console.log("handleLogoChange", file, fileList);
      this.fileLogoList = fileList
      this.logoChanged = true
    },

  }

}
</script>


<style scoped lang="less">

.main-form {
  //margin: 10px;
  min-height: 400px;
  //height: 50vh;

  .form-item-length {
    width: 300px;
  }
}


</style>
